import { ErrorResponse } from "types";

export const authHeader = contentType => {
	// return authorization header with jwt token
	let userStr = localStorage.getItem("user") || "";
	let user = JSON.parse(userStr);
	if (user && user.access_token) {
		let headers = {
			Authorization: "Bearer " + user.access_token,
		};
		if (contentType) {
			headers["Content-Type"] = contentType;
		}
		return headers;
	} else {
		return {};
	}
};

export const convertNumbersToString = data => {
	// JS loose precision of big float numbers
	data = data.replace(/([[:])?([\d.-]+)([,}\]])/g, '$1"$2"$3');
	return JSON.parse(data);
};

export const encodeUrlValues = ({ ...values }) => {
	for (const key in values) {
		values[key] = values[key] && encodeURIComponent(values[key]);
	}
	return values;
};

export function getErrorMessage(error: ErrorResponse) {
	let message: string | undefined = "Problem encountered. Please try again";
	if (typeof error === "string") {
		message = error;
	} else if (error?.detail) {
		message = error.detail;
	} else if (error?.errors) {
		message = error?.errors[Object.keys(error.errors)[0]][0];
	} else if (error?.title) {
		message = error?.title;
	}
	return message;
}
